import React from 'react';
import styled, { useTheme } from 'styled-components';
import {
  CustomFlexContainer,
  ExampleButton,
  ResponsiveButtonContainer,
  // @ts-expect-error - TS7016 - Could not find a declaration file for module './consent_extension_email.styles'. 'app/webpack/javascripts/gdpr/components/consent_extension_emails/consent_extension_email.styles.js' implicitly has an 'any' type.
} from './consent_extension_email.styles';
import {
  DangerButton,
  PrimaryButton,
} from '@grnhse/seedling/lib/birch/components/buttons';
import { colors } from '@grnhse/seedling/lib/azalea/constants';
import { Checkmark, XIcon } from '@grnhse/seedling/lib/azalea/icons';

type Props = {
  approveText: string;
  denyText: string;
};

function ThemedButtons(props: Props) {
  const theme = useTheme();

  // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'DefaultTheme'.
  if (theme?.name === 'birch') {
    return (
      <>
        <ResponsiveButtonContainer>
          <PrimaryButton disabled onClick={() => {}}>
            {props.approveText}
          </PrimaryButton>
        </ResponsiveButtonContainer>
        <ResponsiveButtonContainer>
          <DangerButton disabled onClick={() => {}}>
            {props.denyText}
          </DangerButton>
        </ResponsiveButtonContainer>
      </>
    );
  }

  return (
    <>
      <ExampleButton
        disabled={true}
        color={colors.white}
        background={colors.mediumGreenhouseGreen}
        width={'100%'}
      >
        <IconAndLabelContainer>
          <Checkmark color={colors.white} />
          <ButtonLabelSpacer>{props.approveText}</ButtonLabelSpacer>
        </IconAndLabelContainer>
      </ExampleButton>
      <ExampleButton
        disabled={true}
        color={colors.white}
        background={colors.darkRed}
        width={'100%'}
        wrap={'wrap-reverse'}
      >
        <IconAndLabelContainer>
          <XIcon color={colors.white} />
          <ButtonLabelSpacer>{props.denyText}</ButtonLabelSpacer>
        </IconAndLabelContainer>
      </ExampleButton>
    </>
  );
}

export function ConsentDecisionButtons(props: Props) {
  return (
    <CustomFlexContainer
      wrap={'wrap-reverse'}
      marginTop={20}
      direction={'column'}
    >
      <ThemedButtons {...props} />
    </CustomFlexContainer>
  );
}

const IconAndLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const ButtonLabelSpacer = styled.span`
  margin-left: 4px;
`;
